import { tab } from "@material-tailwind/react";
import { Box, Tabs, Tab } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { FC, useEffect, useState } from "react";
import { DomainEnum, DomainTypeColumnList, DomainTypesList } from "../../../environment";
import DomainTable from "./DomainTable";

import useDomainStore from "../../../stores/useDomainStore";

type DomainManagementProps = {};
const DomainManagement: FC<DomainManagementProps> = (): JSX.Element => {
  const [currTab, setCurrTab] = useState<string>(DomainTypesList?.[0].key);
  const [currTableRows, setCurrTableRows] = useState<Array<any>>([]);
  const [currTableCols, setCurrTableCols] = useState<Array<any>>([]);
  const domainDetails = useDomainStore();
  useEffect(() => {
    if (currTab) {
      const tempTableColumns = DomainTypeColumnList.find(
        (self) => self.domainKey === currTab
      )?.columns;
      if (tempTableColumns) {
        setCurrTableCols(tempTableColumns);
      }
    }
  }, [currTab]);
  useEffect(() => {
    switch (currTab) {
      case DomainEnum.SUBJECT:
        setCurrTableRows(domainDetails.subjects);
        break;
      case DomainEnum.COMPLEXITY:
        setCurrTableRows(domainDetails.complexity);
        break;
      case DomainEnum.LANGUAGE:
        setCurrTableRows(domainDetails.language);
        break;
      case DomainEnum.MARKS:
        setCurrTableRows(domainDetails.marks);
        break;
    }
  }, [currTab]);

  return (
    <section
      id="sample-paper"
      className={` flex flex-col items-center justify-center`}
    >
      <div className="container w-full py-4 lg:w-[90%] md:w-[100%] mx-auto">
        {/* <div className="my-5">
        <GeneralKATable
          tableColumns={ColumnData}
          tableData={[
            {
              grn: "34903",
              period_from: new Date("12-03-2023"),
              period_to: new Date("12-04-2023"),
              txn_time: new Date("1-05-2023"),
              amount: 890,
              options:[
                {
                  name:"Apple",
                  isCorrect:true
                },
                {
                  name:"Banana",
                  isCorrect:false
                },
                {
                  name:"Guava",
                  isCorrect:false
                },
              ],
              status: "active"
            },
            {
              grn: "34903",
              period_from: new Date("10-01-2023"),
              period_to: new Date("1-4-2023"),
              txn_time: new Date("01-05-2023"),
              amount: 80,
              options:[
                {
                  name:"Apple",
                  isCorrect:true
                },
                {
                  name:"Banana",
                  isCorrect:false
                },
                {
                  name:"Guava",
                  isCorrect:false
                },
              ],
              status: "active"
            }
          ]}
        />
      </div> */}
        <div className="bg-white rounded shadow-lg p-4 px-4 md:p-8 flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <p className="text-2xl font-semibold mb-5">Domain List</p>
          </div>

          <div className="mb-3">
            <Box
              className="border-b-2"
              sx={{
                bgcolor: "background.paper",
              }}
            >
              <Tabs
                value={currTab}
                onChange={(event: any, newValue: any) => setCurrTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                {DomainTypesList.map((item: any, index: number) => (
                  <Tab label={item.label} key={index} value={item.key} />
                ))}
              </Tabs>
            </Box>
          </div>

          <div className="flex items-center justify-end mt-5 mb-5">
            <button
              type="button"
              onClick={() => {}}
              className={`w-[150px] bg-[#2d69eb] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm px-5 py-2.5 mt-[10px] text-center`}
            >
              + Add New
            </button>
          </div>
          <DomainTable columns={currTableCols} rows={currTableRows} />
        </div>
      </div>
    </section>
  );
};

export default DomainManagement;
